export const Paths = {
    default: '/api/customer-portal/users',
};
